import React from "react";
import { useQuickSightQuick } from "@/hooks/useQuickReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAwsQuickDashboard from "@/components/organisms/QuickDashboard";

function QuickReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightQuick();

  return (
    <AWSReportsTemplate
      title="AWS Quick Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAwsQuickDashboard />
    </AWSReportsTemplate>
  );
}

export default QuickReports;
